import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import email1 from "../Images/email1.png";
import op7 from "../Images/op7.png";
import opm1 from "../Images/opm1.png";
import opm3 from "../Images/opm3.png";
import opm2 from "../Images/opm2.jpg";
import opm4 from "../Images/opm4.png";
import { Link } from "react-router-dom";

export default function OperationalManagement() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="An operational CRM is designed to improve routine business operations and securely store data on all your business activities with customers and prospects"
      />
      <meta property="og:title" content="Operational Management" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/operationalmanagement"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/email1.png"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/email1.png"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="An operational CRM is designed to improve routine business operations and securely store data on all your business activities with customers and prospects"
      />
      <meta property="og:locale" content="en_US" />

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Operational Management",
      "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://www.entelipro.com/operationalmanagement"`}
        `
      </script>

      <title>
        Operational Management | Best CRM Software |Pharmaceutical Industry ::
        entelipro.com
      </title>

      <Navbar />
      {/* <!-- breadcrumbs --> */}
      <section class="w3l-inner-banner-main">
        <div class="about-inner inner2">
          <div class="container seen-w3">
            <ul class="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/pharmaceutical">
                  Pharmaceutical Industry{" "}
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li class="active">Operational Management</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="main-titles-head text-center">
              <h3 class="header-name">Operational Management</h3>
            </div>
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={email1} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <p class="para">
                  {" "}
                  An operational CRM is designed to improve routine business
                  operations and securely store data on all your business
                  activities with customers and prospects.
                </p>
                <br />
                <br />{" "}
                <p class="para">
                  {" "}
                  CRM features enable businesses to measure, analyze, and tailor
                  the customer journey in real-time.
                </p>
                <br />
                <br />
                <p class="para">
                  {" "}
                  A centralized system that supports the sales, marketing, and
                  customer service functions within a company that stores
                  information on customers, leads, and employees using a shared
                  interface.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h4>What makes operational CRM different?</h4>
                <p class="para">
                  {" "}
                  1. Primary Functions: Sales, Service, and Support.
                  <br />
                  <br />
                  2. Perfect for customer-facing functions. <br /> <br />
                  3. Connects marketing, sales, and customer service teams.{" "}
                  <br />
                  <br />
                  4. Automates many functions including scheduling, follow-ups,
                  and contacts.
                  <br />
                  <br />
                  5. Facilitates customer self-service functions.
                  <br />
                  <br />
                </p>
              </div>
              <div class="col-xl-6 cwp4-image ">
                <img src={op7} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <div class="main-titles-head text-center">
            <h3 class="header-name">
              Operational CRM help you add a personal touch
              <br /> without the personal effort.
            </h3>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Increased Customer Satisfaction </h3>{" "}
                <br />
                <p class="para">
                  {" "}
                  An operational CRM provides all this data and more, so your
                  customer service team can have a holistic view of the
                  customer's relationship with your company.
                </p>
              </div>

              <div class="col-xl-6 cwp4-image ">
                <img src={opm1} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={opm2} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Increase Revenue </h3> <br />
                <p class="para">
                  Operational CRMs are known to produce more than $8 of value
                  for every $1 invested in them. At an 8:1 ROI, you can't go
                  wrong with a CRM for your business. Scaling your sales team
                  and giving them tools to sell and close better will
                  undoubtedly increase your company's revenue.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Increase internal communication</h3>{" "}
                <br />
                <p class="para">
                  {" "}
                  When an organization has access to the same information it
                  puts them all on the same field, playing the same game. The
                  operational CRM's ability to capture, store, and disseminate
                  data makes it a great tool for inter-departmental
                  communication and information sharing.{" "}
                </p>
              </div>

              <div class="col-xl-6 cwp4-image ">
                <img src={opm3} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={opm4} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">
                  Maximize up-selling <br />
                  and cross-selling
                </h3>{" "}
                <br />
                <p class="para">
                  Operational CRM starts capturing your customer's data from the
                  first touch-point and it maintains those records through the
                  life-cycle of the customer, logging each sale, contact, and
                  issue. This sets up your sales team for the perfect up-sell
                  and cross-sells opportunities. With purchase history available
                  to them, sales reps can use sales tactics tailored for each
                  client.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
